import { css } from '@emotion/react';
import { Animation, Colors, Heading, HeadingLevel, Img, Link, Typography, } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';
import { useUniversalNavContext } from '../../../hooks/useUniversalNavContext';
import { emitUserInteractionEvent } from '../../../utils/avroEvents';
import { ArrowLinkIcon } from '../MegaMenuSubmenu';
const Styles = {
    root: css(Object.assign(Object.assign({ color: Colors.neutral800, display: 'flex', flexDirection: 'column', position: 'relative', maxWidth: 400 }, Typography.smallPrint1Bold), { '@media (hover: hover)': {
            '&:hover p': {
                textDecoration: 'underline',
            },
            '&:hover a': {
                textDecoration: 'none',
            },
            '&:hover p > span': {
                marginLeft: 4,
                opacity: 1,
            },
            '&:focus-within': {
                outline: `1px solid ${Colors.blue}`,
            },
            '&:focus-within > a': {
                textDecoration: 'none',
            },
        } })),
    title: css({
        display: 'block',
        marginBottom: 20,
        textDecoration: 'none',
        color: Colors.neutral800,
        outline: 'none',
        borderBottom: 'none',
        '&:hover': {
            textDecoration: 'none',
            color: Colors.neutral800,
        },
        '&:focus': {
            textDecoration: 'none',
            color: Colors.neutral800,
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            zIndex: 1,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
    }),
    imageContainer: css({
        display: 'flex',
        alignItems: 'center',
        gap: 16,
    }),
    description: css(Object.assign({ transition: `text-decoration 100ms ${Animation.transitionTimingFunction}`, display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 3, overflow: 'hidden' }, Typography.smallPrint1)),
};
export const ArticlePromo = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `ArticlePromo: ${text}`,
        });
        if (eventType === 'click' && props.onCloseMenu)
            props.onCloseMenu();
    };
    return (isolateComponent("article", { css: Styles.root },
        isolateComponent(HeadingLevel, null,
            isolateComponent(Heading, null,
                isolateComponent(Link, { color: null, css: Styles.title, href: getFullyQualifiedURL(props.href) || undefined, onClick: () => handleEvent(props.text, 'click'), onMouseEnter: () => handleEvent(props.text, 'hover'), target: props.target }, props.text))),
        isolateComponent("div", { css: Styles.imageContainer },
            isolateComponent(Img, { alt: props.altText, borderRadius: 0, src: props.imageUrl, width: 100 }),
            isolateComponent("p", { css: Styles.description },
                props.description,
                isolateComponent(ArrowLinkIcon, null)))));
};
//# sourceMappingURL=ArticlePromo.js.map
// @zapier/universal-layout@8.6.23 (c29ded5a6)
